import { render } from "./crm.vue?vue&type=template&id=55d8508d&scoped=true"
import script from "./crm.js?vue&type=script&lang=js"
export * from "./crm.js?vue&type=script&lang=js"

import "./crm.vue?vue&type=style&index=0&id=55d8508d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d8508d"]])

export default __exports__